<template>
  <div class="input">
    <label
      :for="inputId"
      class="input-label text-left"
      :aria-label="label"
      :aria-required="required ? 'true' : 'false'"
    >
      {{ label }}<span v-if="required" aria-hidden="true">*</span>
    </label>
    <textarea
      :id="inputId"
      :value="value"
      :placeholder="placeholder"
      :aria-required="required ? 'true' : 'false'"
      :aria-invalid="error ? 'true' : 'false'"
      :aria-describedby="error ? errorId : null"
      class="input-field"
      @input="onInput"
      v-bind="$attrs"
      :tabindex="$attrs.tabindex !== undefined ? $attrs.tabindex : 0"
      autocomplete="off"
      rows="4"
      :maxlength="maxLength"
    />
    <div class="textarea-counter" aria-live="polite">{{ value.length }}/{{ maxLength }}</div>
    <div v-if="error" :id="errorId" class="input-error" role="alert" aria-live="assertive">
      <font-awesome-icon :icon="['fas', 'circle-exclamation']" /> {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'TextArea',
  props: {
    value: String,
    label: { type: String, required: true },
    placeholder: { type: String, default: '' },
    error: { type: String, default: '' },
    required: { type: Boolean, default: false },
    id: { type: String, default: null },
    maxLength: { type: Number, default: 500 },
  },
  computed: {
    inputId() {
      return this.id || `textarea-${this._uid}`;
    },
    errorId() {
      return `textarea-error-${this._uid}`;
    },
  },
  methods: {
    onInput(event) {
      let val = event.target.value;
      if (val.length > 500) val = val.slice(0, 500);
      this.$emit('input', val);
    }
  }
};
</script>

<style scoped>
.input {
  display: flex;
  flex-direction: column;
  margin-bottom: 1rem;
}
.input-label {
  font-weight: 600;
  margin-bottom: 0.25rem;
}
.input-field {
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  text-align: left;
  resize: vertical;
}
.input-field[aria-invalid="true"] {
  border-color: #e53935;
}
.input-error {
  color: #e53935;
  font-size: 0.875rem;
  margin-top: 0.25rem;
  text-align: left;
}
.textarea-counter {
  font-size: 0.85rem;
  color: #888;
  text-align: right;
  margin-top: 0.1rem;
}
</style>
